var string = { exports: {} };
export {
  string as __module
};
//# sourceMappingURL=string.js.map
